<!--
    Styles
-->

<style scoped>

    tr th {
        font-weight: 400;
        text-align: left;
    }
    tr th.sortable {
        cursor: pointer;
    }
    tr th.active {
        color: var(--cl-blue);
    }

</style>



<!--
    Template
-->

<template>
    <tr class="cl-gray t12">

        <th @click="check"><ui-checkbox :active="checked" /></th>

        <th
            v-for="col in columns"
            :key="col"
            :class="{sortable: sortable[col], active: active(col)}"
            @click="sort(col)"
        >
            <span v-show="!hidden(col)">{{ fields[col] }}</span>
            <span v-show="active(col)">{{ sortParam[1] === 'asc' ? '▴' : '▾' }}</span>
        </th>

        <th>操作</th>
        <th />

    </tr>
</template>



<!--
    Scripts
-->

<script>


    import {mapState} from 'vuex'
    import uiCheckbox from '@/components/shared/ui/checkbox.vue'
    import fields from '@/common/configs/fields'
    import filters from '@/common/configs/filters'

    const sortable = filters.sort.reduce((acc, key) => ({...acc, [key]: true}), {});

    export default {

        components: {
            uiCheckbox
        },

        props: ['checked'],

        data () {
            return {
                fields,
                sortable
            }
        },

        computed: {

            ...mapState('search', ['params']),

            ...mapState('deals', ['columns']),

            sortParam () {
                const {sort: [by, order] = []} = this.params;
                return [by, order];
            }

        },

        methods: {

            check (event) {
                this.$emit('check', event);
            },

            active (col) {
                return this.sortParam[0] === col;
            },

            hidden (key) {
                return key === 'done';
            },

            set (query) {
                this.$router.push({
                    name: this.$route.name,
                    query: {...this.$route.query, ...query}
                });
            },

            sort (key) {
                let [by, order = 'asc'] = this.sortParam;
                if (by === key) order = order === 'asc' ? 'desc' : 'asc';
                this.set({sort: key && [key, order]});
            },

            reset () {
                // eslint-disable-next-line
                const {name, query: {sort, search, ...query}} = this.$route;
                this.$router.push({name, query});
            }

        },

        created () {
            this.reset();
        },

        destroyed () {
            this.reset();
        }

    }

</script>
